import { TeamAvatar } from '@sorare/core/src/components/club/TeamAvatar';
import { ASSETS_HOST } from '@sorare/core/src/constants/assets';
import { GqlFilterTitle } from '@sorare/core/src/contexts/graphql-search';
import { FILTERS, type FilterWidget } from '@sorare/core/src/lib/filters';

import {
  RefineBackendI18nList,
  buildRefineI18nList,
} from '#src/searchCards/RefineI18nList/index.tsx';

const getAvatarUrl = (slug: string) =>
  `${ASSETS_HOST}/team/picture/icons/${slug}.png`;

const sliceLongNameWithSlug = (option: string) => {
  const [name, slug] = option.split('|');
  return { name, slug };
};

const renderBefore = (option: string) => {
  const { name, slug } = sliceLongNameWithSlug(option);

  return (
    <TeamAvatar
      size={24}
      team={{
        __typename: 'Club',
        slug,
        name,
        avatarUrl: getAvatarUrl(slug),
      }}
    />
  );
};

export const RefineClub = (limit?: number) =>
  buildRefineI18nList({
    filter: FILTERS.team,
    renderBefore,
    limit,
  });
export const RefineActiveClub = (limit?: number) =>
  buildRefineI18nList({
    filter: FILTERS.activeClub,
    renderBefore,
    limit,
  });

export const RefineBackendActiveClub = (limit?: number) => {
  return {
    key: 'club',
    type: 'list',
    attribute: 'club',
    Component: ({ visible }) => (
      <RefineBackendI18nList
        visible={visible}
        attribute="club"
        renderBefore={renderBefore}
        limit={limit}
      />
    ),
    title: <GqlFilterTitle name="club" title={FILTERS.activeClub.title} />,
    accordionOptions: { startsOpen: false },
  } satisfies FilterWidget;
};
